import { render, staticRenderFns } from "./ArsaTanimla.vue?vue&type=template&id=4aeb931b&"
import script from "./ArsaTanimla.vue?vue&type=script&lang=js&"
export * from "./ArsaTanimla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports